<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col>
          <configuration-firstscreen
            v-if="showFirstScreen"
            :configuration-type="conf.type"
            :planogramms="conf.planogramm"
            :screen="conf.interface_description.first_screen"
            :nomenclatures="nomenclatures"
            @data="onStartToPay"
            @screen="onShowSecondScreen"
          />
          <configuration-second-screen
            v-if="showSecondScreen"
            :configuration-type="conf.type"
            :item="itemForSecondScreen"
            :planogramms="conf.planogramm"
            :screen="conf.interface_description.first_screen"
            :nomenclatures="nomenclatures"
            @cancel="onShowFirstScreen"
            @data="onStartToPay"
          />
          <configuration-error-screen
            v-if="showErrorScreen"
            :screen="conf.interface_description.error_screen"
          />
          <configuration-relay-screen
            v-if="showRelayScreen"
            :screen="currentRelayScreen"
            @onClick="onStartToAction"
          />
          <configuration-final-screen
            v-if="showFinalScreen"
            :cheque="cheque"
            :screen="conf.interface_description.final_screen"
            @showCheque="onCheque"
          />
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-container>
    <v-row>
      <v-dialog
        v-model="showPaymentScreen"
        fullscreen
        hide-overlay
      >
        <v-card>
          <v-toolbar
            flat
            dense
            collapse
          >
            <v-btn
              small
              icon
              @click="onClosePaymentScreen"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <iframe
            :src="nspkLink"
            width="100%"
            height="100%"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>
<script>

import ConfigurationFirstscreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationFirstscreen.vue"
import { configuration } from "@/views/loyalty/models/justpay-configuration.model"
import { guid, setScreenBackground } from "@/views/loyalty/shared/modules/utilities"
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import { JustpayPaymentMqttService } from "@/views/loyalty/shared/services/justpay-paymentmqtt-service"
import ConfigurationErrorScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationErrorScreen.vue"
import { RelayHandler } from "@/views/loyalty/shared/classes/relay/relay_handler"
import { MqttDingtianService } from "@/views/loyalty/shared/services/mqtt-dingtian-service"
import ConfigurationRelayScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationRelayScreen.vue"
import ConfigurationFinalScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationFinalScreen.vue"
import { SbpStateEnum } from "@/views/loyalty/models/justpay-sbp.model"
import ConfigurationSecondScreen
  from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationSecondScreen.vue"
export default {
  components: { ConfigurationSecondScreen, ConfigurationFinalScreen, ConfigurationRelayScreen, ConfigurationErrorScreen, ConfigurationFirstscreen },
  data: () => ({
    cheque: '',
    conf: configuration,
    configurationService: null,
    currentRelayScreen: {},
    equipment: null,
    // equipmentService: null,
    guid: null,
    itemForSecondScreen: {},
    mqttDingtianService: null,
    nomenclatures: [],
    // needToCloseScenario: false,
    nspkLink: null,
    overlay: false,
    paymentMqttService: null,
    paymentService: null,
    pointService: null,
    relayHandler: null,
    relaySerialNumber: '',
    relayScenario: {},
    sbpId: null,
    sbpState: 0,
    scenarioRelay: {},
    showErrorScreen: false,
    showFinalScreen: false,
    showFirstScreen: true,
    showPaymentScreen: false,
    showRelayScreen: false,
    showSecondScreen: false,
    timeoutSbp: 0,
    timerId: null,
    wasFired: false // whether fired doPage
  }),
  watch: {
    'relayHandler.currentScreen': function (newScreen) {
      console.log('^^^ current screen', newScreen)
      this.currentRelayScreen = newScreen
    },
    'relayHandler.viewRelayScreen': function (newVal) {
      console.log('^^^ showRelay is changed ^^^', newVal)
      if (!this.showFirstScreen && !newVal) {
        this.showFinalScreen = this.showScreen()
      }
      },
    'relayHandler.needToCloseScenario': function (newVal) {
      console.log('^^^ need to close scenario', newVal)
      if (newVal) {
        if (this.sbpState === SbpStateEnum.Paid) {
          this.showFinalScreen = this.showScreen()
        } else {
          this.showErrorScreen = this.showScreen()
        }
      }
    },
    showErrorScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.error_screen.background)
      }
    },
    showFinalScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.final_screen.background)
      }
    },
    showFirstScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.conf.interface_description.first_screen.background)
      }
    },
    async showRelayScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.currentRelayScreen.background)
        await this.onStartToAction()
      }
    }
  },
  async beforeMount () {
    this.mqttDingtianService = new MqttDingtianService()
    this.paymentMqttService = new JustpayPaymentMqttService()
    this.paymentSystemService = new JustpayPaymentSystemService()
    this.showFirstScreen = this.showScreen()

    this.pointId = this.$route.query.id
    this.$store.state.pointId = this.pointId
    console.log('pointId', this.pointId)
    const response = await this.paymentMqttService.getConf(this.pointId)
    console.log('response', response)
    console.log('response.configuration', response.configuration)
    if (response.configuration) {
      this.conf = response.configuration
      this.nomenclatures = response.nomenclatures
      this.relayScenario = response.configuration.releScenarios[0]
    }
    this.timeoutSbp = await this.paymentMqttService.getTimeout() // the data is taken from server configuration
    // this.timeoutSbp = 10 // for testing
    console.log('timeoutSBp', this.timeoutSbp)
    this.relayHandler = new RelayHandler(this.conf)
  },
async mounted () {
  this.guid = guid()
},
  methods: {
    getDataForSendingToRelay () {
      const dataArray = []
          this.relayScenario.releConf.pages.forEach(page => {
            page.actions.forEach(action => {
              dataArray.push({
                command: action.command.type, // number of command
                number: this.equipment.serial,
                relayIndex: action.command.number,
                repeats: { beforeTimeout: action.before_timeout, afterTimeout: action.after_timeout },
                timeout: action.command.time
              })
            })
          })
      console.log('getDataForSendingToRelay dataArray', dataArray)
      return dataArray
    },
    async startScanSbpState (dbpId) {
      this.sbpState = await this.paymentMqttService.getSbpState(dbpId)
      // this.sbpState = SbpStateEnum.Paid // for testing
      // await that.relayHandler.sleep(10) // for testing
      console.log('sbpState', this.sbpState)
      if (this.sbpState === SbpStateEnum.Paid) {
        this.showFinalScreen = this.showScreen()
        clearInterval(this.timerId)
      }
    },
    async stopScanSbpState (timerId) {
      clearInterval(timerId)
      if (this.sbpState === SbpStateEnum.Paid) {
        this.showFinalScreen = this.showScreen()
      } else {
        this.showErrorScreen = this.showScreen()
      }
    },
    async onCheque () {
      this.cheque = await this.paymentSystemService.getCheque(this.paymentId)
    },
    async onClosePaymentScreen () {
      clearInterval(this.timerId)
      this.showErrorScreen = this.showScreen()
    },
    onShowFirstScreen () {
      this.showFirstScreen = this.showScreen()
    },
    onShowSecondScreen (item) {
      console.log('onShowSecondScreen item', item)
      this.itemForSecondScreen = item
      this.showSecondScreen = this.showScreen()
    },
    async onStartToAction () {
      if (!this.wasFired && !this.showErrorScreen) {
        // await this.relayHandler.doPage()
        // this.screenStateHandler.viewFinalScreen(this) // to show immediately the final screen
      }
      this.wasFired = true
    },
    // items = [{amount, count, equipmentId, name, price, scenarioId}]
    async onStartToPay (items) {
      console.log('items', items)
      console.log('items[0].scenarioId', items[0].scenarioId)
      this.relayHandler.scenarioId = items[0].scenarioId
      this.equipment = await this.paymentMqttService.getEquipment(items[0].equipmentId)
      this.relayHandler.relayNumber = this.equipment || {} ? this.equipment.serial : '' // set relay number
      console.log('equipment', this.equipment)
      // to check whether ready relay channel
      const isBusy = await this.relayHandler.isRelayBusy(items[0].scenarioId)
      if (isBusy) {
        this.showErrorScreen = this.showScreen()
        console.log('Relay is busy')
        return
      }
      this.currentRelayScreen = this.relayHandler.getCurrentRelayScreen(items[0].scenarioId)
      this.overlay = true // show progress circular
      // const response = { value: { error: false } } // for testing
      const response = await this.paymentSystemService.createPayment({ idempotency: this.guid, pointId: this.pointId, items: items, sum: items[0].amount, resultPage: 3 }) // resultPage = 3 (ResultPageEnum.QrRelayPay)
      this.overlay = false
      console.log('createPayment response', response)
      if (response.value.error) {
        this.showErrorScreen = this.showScreen()
        console.log('error', response.value.error)
      } else {
        this.nspkLink = response.value.data.qr
        this.sbpId = response.value.data.sbp
        this.paymentId = response.value.data.paymentId
        // this.sbpId = 0 // for testing
        await this.paymentMqttService.sendMessage({ isRepeat: true, relayRequests: this.getDataForSendingToRelay(), sbpId: this.sbpId, timeout: this.timeoutSbp })
        this.showPaymentScreen = this.showScreen()
        this.timerId = setInterval(this.startScanSbpState, 1000, this.sbpId) // to scan the state of sbp payment
        setTimeout(this.stopScanSbpState, this.timeoutSbp * 1000, this.timerId) // to stop the scanning in this.timeout seconds
      }
    },
    showScreen () {
      this.showErrorScreen = false
      this.showFinalScreen = false
      this.showFirstScreen = false
      this.showPaymentScreen = false
      this.showRelayScreen = false
      this.showSecondScreen = false
      return true
    },
  }
}
</script>

<style scoped>

</style>
